export default {
    en: require('@/locales/en.json'),
    'en_GB': require('@/locales/en_GB.json'),
    no: require('@/locales/no.json'),
    da: require('@/locales/da.json'),
    nl: require('@/locales/nl.json'),
    fi: require('@/locales/fi.json'),
    fr: require('@/locales/fr.json'),
    de: require('@/locales/de.json'),
    'de_AT': require('@/locales/de_AT.json'),
    'de_CH': require('@/locales/de_CH.json'),
    it: require('@/locales/it.json'),
    es: require('@/locales/es.json'),
    sv: require('@/locales/sv.json'),
};
